<template>
    <v-card flat outlined class="side-file-item">
        <v-text-field
            v-model="form.term"
            v-bind="{
                placeholder: '파일명',
            }"
            flat
            dense
            solo
            hide-details
            class="side-file-item__field"
            @input="emit"
        >
            <template #prepend-inner>
                <v-checkbox v-model="form.isRequired" v-bind="attrs_switch" color="primary" hide-details title="필수여부" @change="emit" />
            </template>
            <template #append>
                <v-icon size="20" color="black" @click="pull"> mdi-minus </v-icon>
            </template>
        </v-text-field>
    </v-card>
</template>

<script>
import { attrs_input, attrs_switch, initEmploymentField } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initEmploymentField },
    },
    data: () => ({
        form: initEmploymentField(),
        attrs_input,
        attrs_switch,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        pull() {
            this.$emit("pull", this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
.side-file-item {
    overflow: hidden;

    &__field {
        margin: -1px 0;
        font-size: 14px;

        ::v-deep() input {
            padding: 8px 4px;
        }
        ::v-deep() .v-input__slot {
            padding: 0 16px 0 4px !important;
            align-items: center !important;

            & > *:not(fieldset) {
                margin: 0 !important;
                padding: 0;
                align-self: center !important;
            }
        }
    }
}
</style>
